// General Settings

export const version = 1.0;
export const clientName = 'Viva Holidays';

export const env = 'PROD';

/* --------------------------------------------------- */

// Api Settings

export const devApiUrl = 'https://vivaapi.stagelab.co.uk/api/';
export const stageApiUrl = 'https://vivaapi.stagelab.co.uk/api/';
export const prodApiUrl = 'https://api.weekender-breaks.com.au/api';

/* --------------------------------------------------- */

// Domain Settings

export const localUrl = 'localhost';
export const stageUrl = 'vivaadmin.stagelab.co.uk';
export const prodUrl = 'admin.viva-holidays.co.uk';

/* --------------------------------------------------- */

// Cloudinary Api Settings.
// Setup a Cloudinary account on behalf of the client.  Input the details here.

export const EAGER = [
    {
        width: 1000,
        height: 1000,
        crop: 'crop',
    },
];

export let cloudinaryApiKey = '394715672258859';
export let cloudinaryApiUploadPreset = 'efiw6rof';
export let cloudinarySecret = 'Seu-PbcKKbZ6YMQ9QEHLHfwiGk4';

if (window.location.hostname === stageUrl) {
    cloudinaryApiKey = '394715672258859';
    cloudinaryApiUploadPreset = 'efiw6rof';
    cloudinarySecret = 'Seu-PbcKKbZ6YMQ9QEHLHfwiGk4';
} else if (window.location.hostname === prodUrl) {
    cloudinaryApiKey = '';
    cloudinaryApiUploadPreset = '';
    cloudinarySecret = '';
}

/* --------------------------------------------------- */



// WEBPACK FOOTER //
// ./src/config/config.js